import { EdgeTypes, MarkerType, type Edge } from "@xyflow/react";
import ElkSmoothStepEdge from "./ElkSmoothStepEdge";
import { EdgeType } from "app/lib/pipeline/graph/EdgeType";
import { EdgeData, EdgeState } from "app/lib/pipeline";

export const edgeTypes: EdgeTypes = {
  [EdgeType.ExplicitDependency]: ElkSmoothStepEdge,
  [EdgeType.ImplicitDependency]: ElkSmoothStepEdge,
};

export function themeEdge(edge: Edge<EdgeData>): Edge<EdgeData> {
  const color = colorForEdge(edge);
  const zIndex = zIndexForEdge(edge);

  return {
    ...edge,
    className: "!pointer-events-none",
    zIndex,
    style: {
      stroke: color,
      strokeWidth: edge.selected ? 4 : 1.5,
    },
    markerEnd: {
      type: MarkerType.Arrow,
      color,
      height: edge.selected ? 6 : 16,
      width: edge.selected ? 6 : 16,
      strokeWidth: 1,
    },
  };
}

function zIndexForEdge(edge: Edge<EdgeData>): number {
  if (edge.selected) {
    return 20;
  }

  switch (edge.data?.state) {
    case EdgeState.Open:
      return 10;
    case EdgeState.Closed:
    default:
      return 0;
  }
}

function colorForEdge(edge: Edge<EdgeData>): string {
  if (edge.selected) {
    return "#086DD7";
  }

  switch (edge.data?.state) {
    case EdgeState.Open:
      return "#c2cace";
    case EdgeState.Closed:
    default:
      return "#eeeeee";
  }
}
